import MicroModal from "micromodal";
import { debounce } from "lodash";
import lazyload from "../util/lazyload";
import Splide from '@splidejs/splide';
import { AutoScroll } from '@splidejs/splide-extension-auto-scroll';
import fitvids from 'fitvids'; 

function setWithExpiry(key, value, ttl) {
  const now = new Date();

  // `item` is an object which contains the original value
  // as well as the time when it's supposed to expire
  const item = {
    value: value,
    expiry: now.getTime() + ttl * 1000,
  };
  localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
  const itemStr = localStorage.getItem(key);
  // if the item doesn't exist, return null
  if (!itemStr) {
    return null;
  }
  const item = JSON.parse(itemStr);
  const now = new Date();
  // compare the expiry time of the item with the current time
  if (now.getTime() > item.expiry) {
    // If the item is expired, delete the item from storage
    // and return null
    localStorage.removeItem(key);
    return null;
  }
  return item.value;
}

// Fitvids

var iframe = document.querySelector('.video__player');
if ( iframe ) 
{
  fitvids({
    players: 'iframe[src*="example.com"]'
  })
}

// Splide

document.addEventListener('DOMContentLoaded', function () {


  if ( $('#hero-slider').length )
  {
    var heroSlider = new Splide( '#hero-slider', {
      type   : 'fade',
      rewind: true,
      arrows: false,
      focus  : 'center',
      perPage: 1,
      pagination: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000
    });
    heroSlider.mount();
  }

  if ( $('#usps-left').length )
  {
    var uspsLeft = new Splide( '#usps-left', {
      type   : 'loop',
      drag   : false,
      focus  : 'center',
      fixedWidth: 317,
      fixedHeight: 440,
      gap: 30,
      arrows: false,
      pagination: false,
      clones: 10,
      autoScroll: {
        speed: .2,
        pauseOnHover: false,
      },
      breakpoints: {
        640: {
          perPage: 1,
          fixedWidth: false,
          clones: 0,
          autoplay    : false,
          pagination: true, 
          autoScroll: {
            speed: 0,
          },
        },
      },
    });
    uspsLeft.mount({ AutoScroll });
  }

  if ( $('#usps-right').length )
  {
    var uspsRight = new Splide( '#usps-right', {
      type   : 'loop',
      drag   : false,
      focus  : 'center',
      direction: 'rtl',
      fixedWidth: 317,
      fixedHeight: 440,
      gap: 30,
      arrows: false,
      pagination: false,
      clones: 10,
      start: 2,
      autoScroll: {
        speed: .2,
        pauseOnHover: false,
      },
    });
    uspsRight.mount({ AutoScroll });
  }

  if ( $('#usps-mobile').length )
  {
    var uspsMobile = new Splide( '#usps-mobile', {
      type   : 'fade',
      drag   : true,
      focus  : 'center',
      rewind : true,
      perPage: 1,
      fixedHeight: 500,
      gap: 30,
      arrows: false,
      pagination: true,
      autoplay: true,
      autoplaySpeed: 3000,
      speed: 1000,
    });
    uspsMobile.mount();

    // USPs section 



    $('.section--usps .slider--links--mobile .usps__link').on('click', function() {
      $('.usps__link').addClass('active');
      $('.overlay__close').addClass('visible');
    });

    $('.section--usps .slider--links--mobile .overlay__close').on('click', function() {
      setTimeout(function() {
        $('.usps__link').removeClass('active');
        $('.overlay__close').removeClass('visible');
      }, 100)
      
    });

    $('.navigation__button--prev').on('click', function() {
      uspsMobile.go('-${i}');
    });

    $('.navigation__button--next').on('click', function() {
      uspsMobile.go('+${i}');
    });

  }
  

  if ( $('#usps-overlay-slider').length )
  {
    var uspsOverlaySlider = new Splide( '#usps-overlay-slider', {
      type   : 'fade',
      drag   : false,
      rewind: true,
      focus  : 'center',
      arrows: false,
      pagination: false,
    });
    uspsOverlaySlider.mount();

    // USPs section 

    $('.section--usps .slider--links--desktop .usps__link').on('click', function() {
      var usp = $(this).data('usp');
      var target = $('.usps__overlay .overlay__content[data-usp="'+ usp +'"]');
      var slideTarget = $('#usps-overlay-slider .splide__slide[data-usp="'+ usp +'"]');
      var slideTargetIndex = slideTarget.data('index');
      target.addClass('active');
      $('.usps__overlay .overlay__content').not(target).removeClass('active');
      $('.usps__overlay').show();
      uspsOverlaySlider.go(slideTargetIndex);
    });
  } 

  $('.navigation__button--prev').on('click', function() {
    uspsOverlaySlider.go('-${i}');
  });

  $('.navigation__button--next').on('click', function() {
    uspsOverlaySlider.go('+${i}');
  });

  $('.navigation__button').on('click', function() {
    setTimeout(function() {
      var usp = $('#usps-overlay-slider .splide__slide.is-active').data('usp');
      var target = $('.usps__overlay .overlay__content[data-usp="'+ usp +'"]');
      target.addClass('active');
      $('.usps__overlay .overlay__content').not(target).removeClass('active');
    }, 50)
  });

});


$('.section--usps .overlay__close').on('click', function() {
  $('.usps__overlay').hide();
});

function capitalizeFirstLetter(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

function changePref(type = false) {
  $(".view-select").removeClass("show");
  $(".pref-active").removeClass("pref-active");
  if ( $('main').hasClass('main--v2') )
  {
    if (!type) {
      $(".pref--sport").addClass("pref-active");
      type = "sport";
    } else {
      $(`.pref--sport`).addClass("pref-active");
      setTimeout(() => {
        $(".pref-select .tooltip").addClass("show");
        setTimeout(() => {
          $(".pref-select .tooltip").removeClass("show");
        }, 4000);
      }, 1000);

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "set_rider_level",
          rider_level: type,
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
        },
      });
    }
    $("td.selected").html("");
    $(".view-select-sticky--choice.checked").removeClass("checked");
    $(`.view-select-sticky--row.selected`).removeClass("selected");
    let row = $(`.view-select-sticky--row[data-type="${type}"]`);
    row.addClass("selected");
    row.find(".view-select-sticky--choice").addClass("checked");
    row.find("td.selected").html("Selected");
    $(".view-select-sticky,.sticky-nav").removeClass("show");
    $(".wrap").removeClass("fade");
    lazyload();
  }
  else
  {
    if (!type) {
      $(".pref--performance").addClass("pref-active");
      type = "performance";
    } else {
      $(`.pref--${type}`).addClass("pref-active");
      setTimeout(() => {
        $(".pref-select .tooltip").addClass("show");
        setTimeout(() => {
          $(".pref-select .tooltip").removeClass("show");
        }, 4000);
      }, 1000);

      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "set_rider_level",
          rider_level: type,
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
        },
      });
    }
  }
}

function changeUnit(type = false) {
  if (!type) return false;
  localStorage.setItem("tbt-unit", type);

  $.ajax({
    url: "/wp-admin/admin-ajax.php",
    type: "post",
    data: {
      action: "set_unit_pref",
      unit_pref: type,
    },
    error: function (err) {
      console.log(err); //eslint-disable-line
    },
  });

  $(".unit-type.active").removeClass("active");
  $(".km-mile").html("");
  $(".m-ft").html("");
  if (type === "metric") {
    $(".metric").addClass("active");
    $(".km-mile").each(function () {
      var z = $(this).attr("data-km");
      $(this).html(z === "-" ? z : `${z} km`);
    });
    $(".m-ft").each(function () {
      var z = $(this).attr("data-m");
      $(this).html(z === "-" ? z : `${z} m`);
    });
  } else {
    $(".imperial").addClass("active");
    $(".km-mile").each(function () {
      var z = $(this).attr("data-mile");
      $(this).html(z === "-" ? z : `${z} mi`);
    });
    $(".m-ft").each(function () {
      var z = $(this).attr("data-ft");
      $(this).html(z === "-" ? z : `${z} ft`);
    });
  }
}

export default {
  init() {
    // prefs
    if (
      $("body").hasClass("enable-rider-levels") ||
      $("body").hasClass("single-product")
    ) {
      let storedPref = $("main.main").data("rider-level");
      if (storedPref) {
        changePref(storedPref);
      } else {
        changePref(storedPref);
        $(".view-select").addClass("show");
      }
      $(".view-select--options--item").on("click", function () {
        $(".view-select--options--item.active").removeClass("active");
        $(this).addClass("active");
        $(".set-pref").removeClass("disabled");
      });

      $(".set-pref").on("click", () => {
        let val = $(".view-select--options--item.active").data("type");
        changePref(val);
      });

      $(".pref-select").on("click", () => {
        $(".sticky-nav").addClass("show");
        $(".wrap").addClass("fade");
        $(".view-select-sticky").addClass("show");
      });

      $(".view-select-sticky--close").on("click", () => {
        $(".sticky-nav").removeClass("show");
        $(".wrap").removeClass("fade");
        $(".view-select-sticky").removeClass("show");
      });

      $(".view-select-sticky--row").on("click", function () {
        let type = $(this).data("type");
        if (!$(this).hasClass("disabled")) {
          changePref(type);
          if ($("body").hasClass("single-product")) {
            setTimeout(() => {
              location.reload();
            }, 1000);
          }
        }
      });
    } else {
      changePref(false);
    }

    let time = 6000;
    $(".hero--carousel").each(function () {
      startCarousel($(this));
    });

    function startCarousel(caller) {
      let to = setTimeout(
        () => {
          moveCarousel(caller);
        },
        caller.data("time") ? parseInt(caller.data("time")) : time
      );
      caller.data("timeout", to);
    }

    function moveCarousel(caller) {
      let total = parseInt(caller.attr("data-total"));
      let current = parseInt(caller.attr("data-current"));
      let next = current + 1 > total ? 1 : current + 1;

      caller.find(".hero--carousel--item.active").removeClass("active");
      caller.find(`.hero--carousel--item--${next}`).addClass("active");
      caller.attr("data-current", next);
      caller.find(".control.active").removeClass("active");
      caller.find(`.control--${next}`).addClass("active");

      startCarousel(caller);
    }

    $(".hero--carousel .control").on("click", function () {
      let caller = $(this).parent().parent();
      clearTimeout(caller.data("timeout"));
      caller.attr("data-current", $(this).data("item"));
      moveCarousel(caller);
    });

    lazyload();
    let prevScroll = 0;
    $(window).on("scroll", function () {
      const ws = $(window).scrollTop();
      const ww = $(window).width();
      if (ws > $(window).height() * 0.5 && (ww > 992 || ws <= prevScroll)) {
        $(".sticky-nav").addClass("in-view");
      } else {
        $(".sticky-nav").removeClass("in-view");
      }
      prevScroll = ws;
      lazyload();
    });

    $(window).on("resize", function () {
      lazyload();
    });

    $("main.main").on("click", function () {
      $(".main-menu").removeClass("open");
      $(".main-menu--second").removeClass("open");
    });

    $(".hamburger").on("click", () => {
      $("body").toggleClass("nav-open");
    });

    $(".imperial").on("click", () => {
      changeUnit("imperial");
    });

    $(".metric").on("click", () => {
      changeUnit("metric");
    });

    changeUnit($("main.main").data("unit"));

    $(".btn--drop").on("click", function () {
      $(this).toggleClass("open");
    });

    $(".trip-nav--toggle").on("click", function () {
      if ($(window).width() < 992) {
        $(this).toggleClass("show");
      } else {
        $(this).removeClass("show");
      }
    });

    // main menu
    $(".menu-toggle").on("click", () => {
      $(".main-menu").addClass("open");
    });

    $(".main-menu--close").on("click", () => {
      $(".main-menu").removeClass("open");
      $(".main-menu--second").removeClass("open");
    });

    $(".main-menu--top p").on("click", function () {
      let target = $(this).attr("data-target");
      $(".main-menu--top p.active").removeClass("active");
      $(this).addClass("active");
      $(".main-menu--content.active").removeClass("active");
      $(`.main-menu--content--${target}`).addClass("active");
      $(".main-menu--second").removeClass("open");
      $("#menu-search").val("");
    });

    $(".main-menu--content > a").on("mouseover", function () {
      if ($(window).width() > 768) {
        if ($(this).hasClass("second-level")) {
          let target = $(this).attr("data-target");
          let second = $(".main-menu--second");
          $(".main-menu--second--section.active").removeClass("active");
          $(`.main-menu--second--${target}`).addClass("active");
          second.addClass("open");
        } else {
          $(".main-menu--second--section.active").removeClass("active");
          $(".main-menu--second").removeClass("open");
        }
      }
    });

    $(".main-menu--content > a").on("click", function () {
      if ($(window).width() <= 768) {
        if ($(this).hasClass("second-level")) {
          let target = $(this).attr("data-target");
          let second = $(".main-menu--second");
          $(".main-menu--second--section.active").removeClass("active");
          $(`.main-menu--second--${target}`).addClass("active");
          second.addClass("open");

          $(".main-menu").addClass("show-second");
        }
      }
    });

    // search menu
    var deb = debounce(ajaxSearch, 1000, false);
    let second = $(".main-menu--second");
    let curVal = "";
    $("#menu-search")
      .on("keyup paste", function () {
        if (curVal != $(this).val()) {
          curVal = $(this).val();
          $(".main-menu--second--section.active").removeClass("active");

          if (curVal.length > 0) {
            second.addClass("open");
            $(`.main-menu--second--search-results`).addClass("active");
            deb(curVal);
          } else {
            second.removeClass("open");
            $(`.main-menu--second--search-results`).removeClass("active");
          }
        }
      })
      .on("keypress", function (e) {
        if (e.which == 13) {
          deb.cancel();
          ajaxSearch(curVal);
        }
      });

    function ajaxSearch(term) {
      $("#results-render").html("");
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "ajax_search",
          search: term,
        },
        success: function (response) {
          // console.log(response); //eslint-disable-line
          renderSearch(JSON.parse(response));
        },
        error: function (err) {
          console.log(err); //eslint-disable-line
        },
      });
    }

    function renderSearch(results) {
      let render = $("<div />", {
        class: "search-results-render",
      });
      $("#results-render").html(render);
      if (results.trips) {
        render.append(
          $("<p />", {
            class: "text-small uppercase spaced search-results-title",
            text: "Trips",
          })
        );
        Object.keys(results.trips).forEach((result_id) => {
          let result = results.trips[result_id];
          render.append(
            $("<a />", {
              class: "text-small search-result",
              text: `${result.title}`,
              href: result.link,
            })
          );
        });
      }
      if (results.journal) {
        render.append(
          $("<p />", {
            class: "text-small uppercase spaced search-results-title",
            text: "Journal",
          })
        );
        Object.keys(results.journal).forEach((result_id) => {
          let result = results.journal[result_id];
          render.append(
            $("<a />", {
              class: "text-small search-result",
              text: `${result.title}`,
              href: result.link,
            })
          );
        });
      }

      if (!results.trips && !results.journal) {
        $("<p />", {
          class: "text-x-small uppercase spaced",
          text: "No results",
        }).appendTo(render);
      }
    }

    // end menu

    $(".departures-toggle").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
      $(this).parent().parent().toggleClass("departures-show");
    });
    checkView();

    document.addEventListener("scroll", function () {
      checkView();
    });

    function checkView() {
      var windowH = $(window).height();
      var stH = $(window).scrollTop();
      $(".trans").each(function () {
        var offsetCS = $(this).offset().top;
        if (offsetCS < windowH * 0.75 + stH) {
          if (!$(this).hasClass("show")) {
            $(this).addClass("show");
          }
        } else {
          $(this).removeClass("show");
        }
      });

      $(".lazyload").each(function () {
        var offsetCS = $(this).offset().top;
        if (offsetCS < windowH + stH) {
          if (!$(this).hasClass("show")) {
            $(this).addClass("show");
          }

          if ($(this).hasClass("lazyload")) {
            $(this).addClass("lazyloaded").removeClass("lazyload");
            $(this).attr("srcset", $(this).data("srcset"));
          }
        }
      });
    }

    // expand collapse
    $(".expand-collapse--trigger").on("click", function () {
      $(this).parent().find(".expand-collapse").toggleClass("open");
      $(this).toggleClass("open");
    });

    $("body").on("click", ".search-results-title", function () {
      $(this).parent().toggleClass("closed");
    });

    // toggle search mob
    $(".toggle-search").on("click", () => {
      if ($("#menu-search").val()) {
        $(".main-menu").toggleClass("show-second");
      }
    });

    $(".toggle-search--back").on("click", () => {
      $(".main-menu").removeClass("show-second");
    });

    $(window).on("resize", () => {
      $(".main-menu--second").removeClass("open");
    });

    $(".update-account-edit").on("click", function () {
      let $frm = $(this).parent().parent();
      $frm.find(".block-input--wrap").toggleClass("active");
      $frm.toggleClass("active");
      $(this).text($(this).text() === "Edit" ? "Cancel" : "Edit");
    });

    $(".form-update-profile").on("submit", function (e) {
      e.preventDefault();
      let formData = {};
      let $frm = $(this);
      let inps = $frm.find("input, select");
      for (let index = 0; index < inps.length; index++) {
        const inp = inps[index];
        formData[inp.name] = inp.value;
        var attr = $(inp).attr("required");
        if (
          typeof attr !== typeof undefined &&
          attr !== false &&
          inp.value == ""
        ) {
          $(inp).addClass("error");
          return false;
        } else {
          $(inp).removeClass("error");
        }
      }
      $(".account-area").addClass("loading");
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "update_account_meta",
          form_data: formData,
          user_id: $frm.data("user"),
        },
        success: function () {
          for (var key in formData) {
            const inp = formData[key];
            var w = $frm.find(".block-input--val[data-name=" + key + "]");
            var i = $frm.find(".block-input--input[name=" + key + "]");
            if (i[0].nodeName === "SELECT" && inp !== "") {
              w.text(i.find("option:selected").text());
            } else {
              w.text(
                key === "billing_email" ? inp : capitalizeFirstLetter(inp)
              );
            }
            if (inp) w.removeClass("hide");
            else if (w.hasClass("hideable")) w.addClass("hide");
          }
          $frm.find(".block-input--wrap").toggleClass("active");
          $frm.find(".update-account-edit").text("Edit");

          $(".account-area").removeClass("loading");
          location.reload();
        },
        error: function () {
          alert("Error saving! Please contact the team");
          $(".account-area").removeClass("loading");
        },
      });
    });

    $(".form-update-user-profile").on("submit", function (e) {
      e.preventDefault();
      let formData = {};
      let $frm = $(this);
      let inps = $frm.find("input, select, textarea");
      for (let index = 0; index < inps.length; index++) {
        const inp = inps[index];

        if ( inp.type == 'checkbox' && $(inp).is(':checked') )
        {
          formData[inp.name] = 1;
        }
        else if ( inp.type == 'checkbox' )
        {
          formData[inp.name] = 0;
        }
        else
        {
          formData[inp.name] = inp.value;
        }
        
        var attr = $(inp).attr("required");
        if (
          typeof attr !== typeof undefined &&
          attr !== false &&
          inp.value == ""
        ) {
          $(inp).addClass("error");
          return false;
        } else {
          $(inp).removeClass("error");
        } 
      }
      $(".account-area").addClass("loading");
      $.ajax({
        url: "/wp-admin/admin-ajax.php",
        type: "post",
        data: {
          action: "update_user_account_meta",
          form_data: formData,
          user_id: $frm.data("user"),
        },
        success: function () {
          $(".account-area").removeClass("loading");
        },
        error: function () {
          alert("Error saving! Please contact the team");
          $(".account-area").removeClass("loading");
        },
      });
    });


    // Footer/Pop up modal mailchimp form submissions

    $(document).ready( function () {
      // I only have one form on the page but you can be more specific if need be.
      var $form = $('#mc-embedded-subscribe-form, #mc-embedded-subscribe-form-popup');

      if ( $form.length > 0 ) {
        $($form).on('submit', function ( event ) {
          event.preventDefault();
          register($(this), event.currentTarget[2].value);
        });
      }
    });

    function register($form, $email) {
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { 
          $('#mce-error-response').append(err).show();
        },
        success     : function(data) {
          if (data.result != "success") 
          {
            $form.find('#mce-error-response').append(data.msg).show();
          } 
          else 
          {
            let url = `/newsletter-preferences/?email=` + encodeURIComponent($email);
            window.location.href = url;
          }
        }
      });
    }


    // Preferences form submission

    $('#mc-embedded-subscribe-form-preferences').on('submit', function(e) {
      e.preventDefault();
      var $form = $(this);
      $.ajax({
        type: $form.attr('method'),
        url: $form.attr('action'),
        data: $form.serialize(),
        cache       : false,
        dataType    : 'json',
        contentType: "application/json; charset=utf-8",
        error       : function(err) { 
          $('#mce-error-response').append(err).show();
        },
        success     : function(data) {
          if (data.result != "success") 
          {
            $form.find('#mce-error-response').append(data.msg).show();
          } 
          else 
          {
            let url = `/newsletter-preferences/?success=1`;
            window.location = url;
          }
        }
      });
    })

    //   let wrap = $(this).parent();
    //   let action = wrap.attr("data-action");
    //   let user_id = wrap.attr("data-user");
    //   if (wrap.hasClass("active")) {
    //     let formData = {};
    //     let inps = wrap.find("input, select");
    //     for (let index = 0; index < inps.length; index++) {
    //       const inp = inps[index];
    //       formData[inp.name] = inp.value;
    //       var attr = $(inp).attr("required");
    //       if (
    //         typeof attr !== typeof undefined &&
    //         attr !== false &&
    //         inp.value == ""
    //       ) {
    //         $(inp).addClass("error");
    //         return;
    //       } else {
    //         $(inp).removeClass("error");
    //       }
    //     }
    //     wrap.find(".block-input--toggle").text("edit");
    //     $(".account-area").addClass("loading");

    //     $.ajax({
    //       url: "/wp-admin/admin-ajax.php",
    //       type: "post",
    //       data: {
    //         action: action,
    //         form_data: formData,
    //         user_id: user_id,
    //       },
    //       success: function () {
    //         for (var key in formData) {
    //           const inp = formData[key];
    //           var w = wrap.find(".block-input--val[data-name=" + key + "]");
    //           var i = wrap.find(".block-input--input[name=" + key + "]");
    //           if (i[0].nodeName === "SELECT") {
    //             w.text(i.find("option:selected").text());
    //           } else {
    //             w.text(capitalizeFirstLetter(inp));
    //           }
    //           if (inp) w.removeClass("hide");
    //           else if (w.hasClass("hideable")) w.addClass("hide");
    //         }
    //         $(".account-area").removeClass("loading");
    //       },
    //       error: function () {
    //         alert("Error saving! Please contact the team");
    //         $(".account-area").removeClass("loading");
    //       },
    //     });
    //   } else {
    //     wrap.find(".block-input--toggle").text("save");
    //   }
    //   wrap.toggleClass("active");
    // });
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
    MicroModal.init({
      disableScroll: true,
      disableFocus: true,
    });

    window.addEventListener("load", function () {
      $(".main").removeAttr("data-animate");
    });

    if ($("#modal-popup").length) {
      const value = getWithExpiry("tbt-popup");

      if (!value) {
        MicroModal.show("modal-popup");
        setWithExpiry("tbt-popup", 1, 604800); // 1 week
      } else {
        //MicroModal.show("modal-popup");
      }

      $(".newsletter-popup-wrap").on("submit", function () {
        $("#modal-popup-content").hide();
        $(".modal__thankyou").show();
      });
    }
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js